import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {Field} from 'formik';

const CustomSelect = ({
                        field,
                        form,
                        meta,
                        label,
                        placeholder = 'בחירה...',
                        onChange,
                        disabled,
                        options,
                        isSearchable = true,
                        customStyles,
                        ...rest
                      }) => {
  const handleChange = (form, field) => option => {
    form.setFieldValue(field.name, option);
    if (onChange) {
      onChange(option);
    }
  };

  const commonProps = {
    styles: customStyles,
    value: field.value,
    onChange: handleChange(form, field),
    placeholder,
    isSearchable,
    isDisabled: disabled,
    ...rest,
  };
  const staticProps = {
    options
  };
  const props = {...commonProps, ...staticProps};

  return (
    <Select {...props}/>
  );
};

const DataItemSelect = ({
                          fieldId,
                          containerStyle = '',
                          labelStyle = '',
                          inputContainerStyle = '',
                          label = null,
                          ...rest
                        }) => (
  <div className={containerStyle}>
    <div className={labelStyle}>{label}</div>
    <div className={inputContainerStyle}>
      <Field
        id={fieldId}
        name={fieldId}
      >
        {fieldProps => <CustomSelect {...fieldProps} {...rest} />}
      </Field>
    </div>
  </div>
);

DataItemSelect.propTypes = {
  fieldId: PropTypes.string,
  placeholder: PropTypes.node,
  onChange: PropTypes.func,
  containerStyle: PropTypes.string,
  sideLabelStyle: PropTypes.string,
  inputContainerStyle: PropTypes.string,
};

export default DataItemSelect;
